
import { Button, ButtonIcon } from '@/components/ui/button';
import { HStack } from '@/components/ui/hstack';
import { VStack } from '@/components/ui/vstack';
import { Icon } from '@/components/ui/icon';
import { Menu, MenuItem, MenuItemLabel } from '@/components/ui/menu';
import { Text } from '@/components/ui/text';
import { Textarea, TextareaInput } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';

import {MaterialCommunityIcons} from "@expo/vector-icons";
import i18n from 'i18n-js';
import LanguageLevelButton from "./LanguageLevelButton";
import LanguageButton from "./LanguageButton";
import CategoryButton from "./CategoryButton";
import NumberOfStepsButton from "./NumberOfStepsButton";
import { useEffect, useState } from "react";
import PromptDialog from "./PromptDialog";
import { useSelector, useDispatch } from 'react-redux';
import { backendRequest } from "../../../stores/thunks";
import ModalPrompt from '../modals/ModalPrompt';
import { IconM } from '@/components/media/IconsV2';

export default function AiPrompt({ visible=false, onApplyAiGraph=(aiJson)=>{}, onClose=()=>{},
                                     getCurrentGraph=()=>{}, ...containerProps }) {

    const internal = useSelector((state) => state.settings.preview)
    const prompt = useSelector((state) => state.ai.prompt)
    const [showPrompt, setShowPrompt] = useState(false)
    const dispatch = useDispatch();

    const buildFilterPrompt = (filters) => {
        let filterPrompt = ''

        if (filters?.languageLevel) {
            filterPrompt += '\n' + prompt.level[filters.languageLevel]
        }

        if (filters?.language) {
            filterPrompt += '\n' + prompt.language.selected.replace(/\$\{lang\}/g, filters.language)
        } else {
            filterPrompt += '\n' + prompt.language.std
        }

        if (filters?.numberOfSteps) {
            filterPrompt += '\n' + prompt.steps.replace(/\$\{min\}/g, filters.numberOfSteps.minimum).replace(/\$\{max\}/g, filters.numberOfSteps.maximum)
        }

        if (filters?.stepTypes) {
            filterPrompt += '\n' + prompt.types.replace(/\$\{types\}/g, filters?.stepTypes?.join(", "))   
        }

        return filterPrompt
    }

    const textToJson = (text) => {
        const jsonMatch = text.match(/\{[\s\S]*\}/)
        if (jsonMatch) {
            return JSON.parse(jsonMatch[0]);
        } else {
            // Answer not JSON
            console.log(resText)
            throw new Error("No valid JSON")
        }
    }

    async function promptChatGPT(userPromptText, filters, currentGraph) {
    
        console.log("Translating via Remote ChatGPT")
        console.log("Selected filters:")
        console.log(filters)
    
        const filterPrompt = buildFilterPrompt(filters)
    
        console.log("Sending request")
    
        console.log("Filter prompts")
        console.log(filterPrompt)
    
        console.log("System prompt:")
        console.log(prompt.base + filterPrompt)
    
        console.log("User prompt:")
        console.log(userPromptText)
    
        const result = dispatch(
            backendRequest('TEXT_AI_CHATGPT_INLINE', '/prompt/',
                JSON.stringify({
                    model: 'gpt-4o-mini',
                    input: [
                        {
                            role: 'system',
                            content: [{ type: 'input_text', text: prompt.base + filterPrompt }]
                        },
                        {
                            role: 'user',
                            content: [
                                { type: 'input_text', text: userPromptText },
                                { type: 'input_text', text: 'This is my current graph: ' + currentGraph }
                            ]
                        }
                    ]
                }),
                'POST',
                false
            )
        )
        console.log('RESPONSE');
        console.log(result);
        return result;
    }
    
    async function promptMistral(userPromptText, filters, currentGraph) {
    
        console.log("Translating via Remote Mistral")
        console.log("Selected filters:")
        console.log(filters)
    
        const filterPrompt = buildFilterPrompt(filters)
    
        console.log("Sending request")
    
        console.log("Filter prompts")
        console.log(filterPrompt)
        console.log("System prompt:")
        console.log(prompt.base + filterPrompt)
        console.log("User prompt:")
        console.log(userPromptText)
    
        const result = dispatch(
            backendRequest('TEXT_AI_MISTRAL_INLINE', '/prompt/',
                JSON.stringify({
                    model: "mistral-small-latest",
                    input: [
                        {
                            role: "system",
                            content: [
                                { type: "text", text: prompt.base + filterPrompt },
                            ]
                        },
                        {
                            role: "user",
                            content: [
                                { type: "text", text: userPromptText },
                                { type: "text", text: "This is my current graph: " + currentGraph },
                            ]
                        }
                    ]
                }),
                'POST',
                false
            )
        )
        console.log('RESPONSE');
        console.log(result);
        return result;
    }
    
    const [filters, setFilters] = useState({})
    const [promptText, setPromptText] = useState("")
    const [loading, setLoading] = useState(false)
    const [messages, setMessages] = useState([])
    const [modelSwitchValue, setModelSwitchValue] = useState(true) // false = ChatGPT, true = Mistral

    const options = [
        {textValue: "languageLevel", label: "Sprachniveau", iconName: "signal-cellular-3"},
        {textValue: "language", label: "Sprache", iconName: "translate"},
        {textValue: "stepTypes", label: "Schrittkategorie", iconName: "format-list-bulleted"},
        {textValue: "numberOfSteps", label: "Anzahl Schritte", iconName: "foot-print"},
    ]

    useEffect(() => {
        console.log("Messages")
        console.log(messages)
    }, [messages])

    useEffect(() => {
        console.log("Filters")
        console.log(filters)
    }, [filters])

    const onMenuPress = filterName => {
        console.log("onMenuPress", filterName)
        addFilter(filterName)
    }

    const addFilter = filterName => {
        let cpyFilter = {
            ...filters
        }
        cpyFilter[filterName] = null
        setFilters(cpyFilter)
    }

    const removeFilter = filterName => {
        let cpyFilters = {...filters}
        delete cpyFilters[filterName]
        setFilters(cpyFilters)
    }

    const onPrompt = () => {
        console.log("onPrompt")
        setLoading(true)
        let userPrompt = promptText
        setMessages(messages => [...messages, {type: 'sent', text: userPrompt}, {type: "loading", text: ""}])
        setPromptText("")

        let currentGraph = JSON.stringify(getCurrentGraph())

        //onApplyAiGraph(testJson2)
        //setLoading(false)
        if (!modelSwitchValue) {
            promptChatGPT(userPrompt, filters, currentGraph)
                .then(result => {
                    const json = textToJson(result)
                    console.log("Received ChatGPT result")
                    console.log(json)
                    onApplyAiGraph(json)
                    setMessages(messages => [...messages.filter(m => m.type !== "loading"), {type: 'received', text: 'Aufgabe wurde erstellt.'}])
                })
                .catch(err => {
                    console.log(err)
                    setMessages(messages => [...messages.filter(m => m.type !== "loading"), {type: 'received', text: 'Ups! Die Anfrage konnte nicht bearbeitet werden!'}])
                })
                .finally(() => setLoading(false))
        } else {
            promptMistral(userPrompt, filters, currentGraph)
                .then(result => {
                    const json = textToJson(result)
                    console.log("Received Mistral result")
                    console.log(json)
                    onApplyAiGraph(json)

                    setMessages(messages => [...messages.filter(m => m.type !== "loading"), {type: 'received', text: 'Aufgabe wurde erstellt.'}])
                })
                .catch(err => {
                    console.log(err)
                    setMessages(messages => [...messages.filter(m => m.type !== "loading"), {type: 'received', text: 'Ups! Die Anfrage konnte nicht bearbeitet werden!'}])
                })
                .finally(() => setLoading(false))
        }


    }

    const onSetFilterValue = (filterName, filterValue) => {
        console.log("onSetFilterValue", filterName, filterValue)
        let cpyFilters = {...filters}
        cpyFilters[filterName] = filterValue
        setFilters(cpyFilters)
    }

    const filterButtonForName = filterName => {
        if (filterName === "languageLevel")
            return <LanguageLevelButton key={filterName} onDelete={() => removeFilter(filterName)} openOnMount={true} filterValue={filters[filterName]} setFilterValue={(value) => onSetFilterValue(filterName, value)} />
        if (filterName === "language")
            return <LanguageButton key={filterName} onDelete={() => removeFilter(filterName)} openOnMount={true} filterValue={filters[filterName]} setFilterValue={(value) => onSetFilterValue(filterName, value)} />
        if (filterName === "stepTypes")
            return <CategoryButton key={filterName} onDelete={() => removeFilter(filterName)} openOnMount={true} filterValue={filters[filterName]} setFilterValue={(value) => onSetFilterValue(filterName, value)} />
        if (filterName === "numberOfSteps")
            return <NumberOfStepsButton key={filterName} onDelete={() => removeFilter(filterName)} openOnMount={true} filterValue={filters[filterName]} setFilterValue={(value) => onSetFilterValue(filterName, value)} />
    }

    return (<VStack className={`${visible ? 'flex' : 'hidden'} justify-between absolute left-0 top-0 p-3 border-[3px] rounded-md border-primary-900 shadow-md bg-primary-50 w-[450px] h-full`} {...containerProps}>
        <VStack>
            <Button
                size="sm"
                variant="outline"
                className="w-9 h-9 self-end border-0 bg-transparent hover:opacity-50"
                onPress={() => onClose()}
            >
                <ButtonIcon
                    as={MaterialCommunityIcons}
                    name="close"
                    size={18}
                    className="text-primary-900"
                />
            </Button>
            <HStack className='items-center gap-2 mb-2'>
                <Text className='text-lg font-semibold text-black'>{i18n.t('studio.flow.aiSupport')}</Text>
                {internal && <IconM className='ml-1 text-primary-900' size={24} onPress={() => { setShowPrompt(true) }} name='edit' />}
            </HStack>
        </VStack>

        <PromptDialog messages={messages} className='flex-1 my-2' />

        <VStack className='mb-9 gap-2'>
            <VStack className='bg-white h-[175px] w-full p-3 gap-1 justify-between border rounded-md border-trueGray-300 shadow-lg'>
                <Textarea
                    className="
                        flex-1 border-0
                        data-[focus=true]:!ring-0
                      "
                >
                    <TextareaInput
                        className="p-0 outline-none text-sm data-[focus=true]:!ring-0"
                        _focusVisible={{
                            outlineWidth: "0 !important",
                            boxShadow: 'none !important',
                        }}
                        placeholder="Schreibe hier..."
                        value={promptText}
                        onChangeText={setPromptText}

                    />
                </Textarea>

                <HStack className='justify-between'>
                    <HStack className='gap-3'>
                        <Menu
                            placement='top left'
                            closeOnSelect={true}
                            offset={10}
                            borderRadius='$md'
                            softShadow={4}
                            trigger={({ ...triggerProps }) => {
                                return (
                                    <Button
                                        {...triggerProps}
                                        size="sm"
                                        variant="outline"
                                        className="w-9 h-9 rounded-full items-center justify-center bg-transparent border border-primary-900 overflow-hidden hover:opacity-50"
                                    >
                                        <ButtonIcon
                                            as={MaterialCommunityIcons}
                                            name="plus"
                                            size={18}
                                            className="text-primary-900"
                                        />
                                    </Button>
                                )
                            }}
                        >
                            <MenuItem
                                py="$2"
                                textValue="Kriterien"
                                pointerEvents="none"
                                sx={{ ":hover": { backgroundColor: "transparent" } }}
                            >
                                <MenuItemLabel sx={{ color: "$black" }}>
                                    <Text className="font-normal">Kriterien</Text>
                                </MenuItemLabel>
                            </MenuItem>
                            {
                                options.map(option => (
                                    <MenuItem key={option.textValue} textValue={option.textValue} onPress={() => onMenuPress(option.textValue)} isDisabled={option.textValue in filters}>
                                        <Icon as={MaterialCommunityIcons} name={option.iconName} size={18} className="text-primary-900 mr-2" />
                                        <MenuItemLabel size='sm'><Text>{option.label}</Text></MenuItemLabel>
                                    </MenuItem>
                                ))
                            }
                        </Menu>

                        {
                            Object.entries(filters).map(([name, value]) => filterButtonForName(name))
                        }
                    </HStack>

                    <Button
                        size="sm"
                        className={`w-9 h-9 rounded-full items-center justify-center border border-primary-900
                                    overflow-hidden bg-primary-900 disabled:opacity-50`}
                        disabled={promptText === "" || loading}
                        onPress={onPrompt}
                    >
                        <ButtonIcon
                            as={MaterialCommunityIcons}
                            name={loading ? 'stop' : 'arrow-right'}
                            size={18}
                            className="color-white"
                        />
                    </Button>
                </HStack>
            </VStack>
            <Text className='text-xs'>{i18n.t('studio.flow.aiErrorWarning')}</Text>

            {internal && <HStack className="gap-2 justify-center">
                <Text>ChatGPT</Text>
                <Switch
                    size="md"
                    value={modelSwitchValue}
                    onToggle={() => setModelSwitchValue(v => !v)}
                />
                <Text>Mistral AI</Text>
            </HStack>}
        </VStack>
        <ModalPrompt prompt={prompt} showModal={showPrompt} setShowModal={setShowPrompt} />
    </VStack>)

}
